export function isString(value: any): value is string {
  return typeof value === 'string' || value instanceof String;
}

export function isObject(value: any): boolean {
  return typeof value === 'object' && !Array.isArray(value) && value !== null;
}
